import type { AdminBuild } from "../../lib/api/admin";
import { elapsedLabel } from "../builds/buildProgress";

export function BuildDetails({ build }: { build: AdminBuild }) {
  const execution = build.execution;
  const engineVersion = execution?.engineVersion ?? build.engineVersion;
  const duration = execution && ["ready", "failed", "cancelled"].includes(execution.status)
    ? elapsedLabel(execution.queuedAt, execution.updatedAt) : null;
  if (!execution && !engineVersion && !build.evaluationGroup && !build.metadata) return null;
  return <details className="admin-build-details">
    <summary>Build details{build.evaluationGroup ? ` · ${build.evaluationGroup}` : ""}</summary>
    <dl>
      {engineVersion && <><dt>Engine</dt><dd>{engineVersion}</dd></>}
      {execution && <><dt>Stage</dt><dd>{execution.stage}</dd><dt>Attempts</dt><dd>{execution.attemptCount}{execution.attemptCount === 1 ? " (first attempt)" : ""}</dd></>}
      {duration && <><dt>Elapsed including queue</dt><dd>{duration}</dd></>}
      {execution?.budget && <><dt>Cost</dt><dd>${execution.budget.usdUsed.toFixed(2)} used · ${execution.budget.usdReserved.toFixed(2)} reserved · ${execution.budget.usdCap.toFixed(2)} limit</dd></>}
      {execution?.failure && <><dt>Failure</dt><dd>{execution.failure.kind}: {execution.failure.code}</dd></>}
      {execution?.artifact && <><dt>Artifact</dt><dd><code>{execution.artifact.id}</code></dd></>}
    </dl>
    <details><summary>Recorded metadata</summary><pre>{JSON.stringify({ ...(execution ? { execution } : {}), ...(build.metadata ?? {}) }, null, 2)}</pre></details>
  </details>;
}
